import { ALL_MODEL_DEFINITIONS } from '../../helpers/MonitorTypeHelpers';

/**
 * Klucz modelu → klasa logotypu (`ico--*-bck`). Wariant `-bck` to prawdziwe, kolorowe logo
 * (`background-image`), a nie maska — dzięki temu ikony wyglądają jak w filtrach panelu.
 *
 * Mapę budujemy z tej samej definicji co etykiety, więc statystyki mogą oddawać model w obu
 * postaciach: jako `ChatType` (`AI_MODE_BROWSER`) i jako zwiniętą rodzinę (`AI_MODE`).
 */
const MODEL_ICONS: Record<string, string> = ALL_MODEL_DEFINITIONS.reduce(
  (map, definition) => {
    map[definition.type] = definition.icon;
    map[definition.modelKey] = definition.icon;
    return map;
  },
  {
    AI_MODE: 'ico--ai-mode',
    AI_OVERVIEW_BROWSER: 'ico--ai-mode',
    // UWAGA na kolizję nazw: w `ALL_MODEL_DEFINITIONS` `AI_OVERVIEW` to klucz UPRAWNIENIA starego
    // AI Mode, ale statystyki oddają rodziny z llm-common, gdzie `AI_OVERVIEW` znaczy NOWE AI
    // Overview (`AI_OVERVIEW_NEW_BROWSER`). Raport dostaje rodziny, więc wygrywa to drugie —
    // bez tego nowy AI Overview pokazywał logo AI Mode.
    AI_OVERVIEW: 'ico--ai-overview-bck',
    GPT_BROWSER: 'ico--gpt-bck',
    GPT_SEARCH: 'ico--gpt-bck',
    GEMINI_BROWSER: 'ico--gemini-bck',
    PERPLEXITY_BROWSER: 'ico--perplexity-bck',
  } as Record<string, string>
);

// Po `reduce`, bo definicje z panelu nadpisałyby wartość początkową swoim `AI_OVERVIEW`.
MODEL_ICONS.AI_OVERVIEW = 'ico--ai-overview-bck';

export const modelIcon = (model: string): string | undefined => MODEL_ICONS[model];
